import * as React from 'react'
import { Button, Dialog } from './ui'
import { PostcodeMap } from './PostcodeMap'
import { lookupPostcodeLocation, type PostcodeLocation } from './postcodeLocation'
import './postcodeMap.css'

export function PostcodeMapDialog({ postcode, onClose }: { postcode: string; onClose: () => void }) {
  const [location, setLocation] = React.useState<PostcodeLocation | null>(null)
  const [error, setError] = React.useState('')
  const [revision, retry] = React.useReducer(value => value + 1, 0)
  React.useEffect(() => {
    const request = new AbortController()
    setLocation(null); setError('')
    void lookupPostcodeLocation(postcode, request.signal).then(result => {
      if (!request.signal.aborted) setLocation(result)
    }).catch(() => {
      if (!request.signal.aborted) setError('We could not find or load this postcode’s location. Please try again.')
    })
    return () => request.abort()
  }, [postcode, revision])

  return <Dialog isOpen purpose="info" width="min(900px, 96vw)" maxHeight="94dvh" aria-label={`Postcode map: ${postcode}`} onOpenChange={open => { if (!open) onClose() }}>
    <div className="postcode-map-dialog">
      <header className="postcode-map-header"><div><span className="eyebrow">POSTCODE LOCATION</span><h2>{postcode}</h2></div><Button type="button" aria-label="Close postcode map" data-autofocus onClick={onClose}>Close</Button></header>
      {error ? <div className="postcode-map-status" role="alert"><h3>Location unavailable</h3><p>{error}</p><Button type="button" className="secondary" onClick={retry}>Retry lookup</Button></div>
        : location ? <PostcodeMap key={location.postcode} location={location} /> : <div className="postcode-map-status" role="status">Finding postcode…</div>}
    </div>
  </Dialog>
}
